import { RepaymentStatement } from '../../../types/repaymentBenefit';
import { backendAuthenticatedAxios } from '../index';

import { AxiosResponse } from 'axios';

interface FetchStatementsResponse {
  results: RepaymentStatement[];
  count: number;
  next: string | null;
  previous: string | null;
}

const fetchRepaymentStatements = async (page: number, pageSize: number): Promise<AxiosResponse<FetchStatementsResponse>> => {
  return backendAuthenticatedAxios.get(
    `/repayment/repayment-benefit/get-repayment-statement-data?page=${page}&page_size=${pageSize}`,
  );
};

export default fetchRepaymentStatements;
